import { MEDIA_BASE_URL } from './config'
import find from 'lodash/find'
import mapValues from 'lodash/mapValues'
import toArray from 'lodash/toArray'
import pick from 'lodash/pick'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

/**
 * Generates a url with the correct absolute address
 * @param {*} src
 */
const generateMediaUrl = (src) => {
  return `${MEDIA_BASE_URL}${src}`
}

/**
 * Finds by id
 * @param {*} identifier
 * @param {*} offerTypes
 */
const findOfferType = (identifier, offerTypes) => find(offerTypes,
  ({ id }) => id === identifier
)

/**
 * Converts an object to array
 * @param {*} object
 */
const mapObjectToarray = (object) => {
  return toArray(
    mapValues(object, (value, key) => {
      return {
        id: key,
        text: key,
        label: key,
        value
      }
    })
  )
}

/**
 * Splits array into separated array
 * @param {*} str
 * @param {*} len
 */
const splitInto = (str, len) => {
  var regex = new RegExp('.{' + len + '}|.{1,' + Number(len - 1) + '}', 'g')
  return str.match(regex)
}

/**
 * Converts CamelCased string to underscored
 * @param {*} str
 */
const convertToUnderscore = (str) => {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
}

/**
 * Converts CamelCase Object to Underscore Object
 * @param {*} obj
 */
const csObjectToUnderscore = (obj) => {
  const newObj = {}

  mapValues(obj, (value, key) => {
    const toUnder = convertToUnderscore(key)
    // if (isObject(value)){
    //   value = csObjectToUnderscore(value)
    // }

    // if (isArray(value)) {
    //   value = value.map((item) => {
    //     if (isObject(item)) {
    //       item = csObjectToUnderscore(item)
    //     }
    //     return item
    //   })
    // }

    newObj[toUnder] = value
  })

  return newObj
}

/**
 *  Converts underscored string to CamelCased
 * @param {*} str
 */
const convertToCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (g) => { return g[1].toUpperCase() })
}

/**
 * Converts Underscore Object to CamelCase Object
 * @param {*} obj
 */
const csObjectFromUnderscore = (obj) => {
  const newObj = {}

  mapValues(obj, (value, key) => {
    const toUnder = convertToCamelCase(key)

    // if (isObject(value)){
    //   value = convertToCamelCase(value)
    // }

    // if (isArray(value)) {
    //   value = value.map((item) => {
    //     if (isObject(item)) {
    //       item = convertToCamelCase(item)
    //     }
    //     return item
    //   })
    // }

    newObj[toUnder] = value
  })

  return newObj
}

/**
 * Simple Select mapper
 * @param {*} param0
 */
const selectMapper = ({ id, name, ...item }) => ({
  label: name,
  value: id,
  ...item
})

/**
 * Captures an Exception to Sentry
 * @param {*} error
 */
const captureSentryException = (error) => {
  if (process.env.NODE_ENV !== 'development') {
    const Raven = require('raven-js')
    Raven.captureException(error)
    // Raven.showReportDialog();}
  }
}

/**
 * Gets the years string from two dates
 * @param {*} firstDate
 * @param {*} secondDate
 */
const getDatesYear = (firstDate, secondDate) => {
  const year1 = moment(firstDate)
  const year2 = moment(secondDate)
  const getYear = (m) => m.format('YYYY')

  if (year1.isValid() && year2.isValid()) {
    return `(${getYear(year1)}-${getYear(year2)})`
  }

  return year1.isValid() ? `(> ${getYear(year1)})` : (year2.isValid() ? `(< ${getYear(year2)})` : '')
}

/**
 * Sorts energy classes alphabetically and by plus char number
 * @param {*} classes
 */
const sortByEnergyClass = (classes) => {
  return classes
    .sort((a, b) => {
      var nameA = a.label.toUpperCase()
      var nameB = b.label.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }

      return 0
    })
    .sort((a, b) => {
      let plusA = a.label.substring(1, a.label.length)
      let plusB = b.label.substring(1, b.label.length)

      if (plusA > plusB) {
        return -1
      }

      if (plusA < plusB) {
        return 1
      }

      return 0
    })
}

const currency = (nr) => Number(nr).toFixed(2).replace('.', ',')

const unitCurrency = (nr) => Number(nr).toFixed(0).replace('.', ',')

const pricesCurrency = (nr) => Number(nr).toFixed(4).replace('.', ',')

const pickOrNot = (values, toPick) => {
  let picked = pick(values, toPick)
  return isEmpty(picked) ? false : picked
}

const validNumber = (v) => Number(String(v).replace(',', '.'))

const replaceDots = (v) => v && String(v).replace('.', ',')

const sendGevent = (category, action, label) =>
  window.ga &&
  window.ga('send', 'event', category, action, label)

const searchToObject = (search) => {
  let pairs = search.substring(1).split('&')
  let obj = {}
  let pair
  let i

  for (i in pairs) {
    if (pairs[i] === '') continue

    pair = pairs[i].split('=')
    obj[ decodeURIComponent(pair[0]) ] = decodeURIComponent(pair[1])
  }

  return obj
}

export {
  generateMediaUrl,
  findOfferType,
  mapObjectToarray,
  splitInto,
  convertToUnderscore,
  csObjectToUnderscore,
  csObjectFromUnderscore,
  selectMapper,
  captureSentryException,
  getDatesYear,
  sortByEnergyClass,
  currency,
  pricesCurrency,
  unitCurrency,
  pickOrNot,
  validNumber,
  replaceDots,
  sendGevent,
  searchToObject
}



// WEBPACK FOOTER //
// ./src/utils.js